import React from "react";
import { createTheme, CssBaseline } from "@mui/material";
import { getTheme, ThemeProvider } from "../../platform-style";

interface PlatformBaseProps {
  children: React.ReactNode;
}

export const PlatformBase = ({ children }: PlatformBaseProps) => {
  const [platformTheme, setPlatformTheme] = React.useState(createTheme(getTheme()));
  React.useEffect(() => {
    window.addEventListener("themeChange", changePlatformTheme);
    return () => window.removeEventListener("themeChange", changePlatformTheme);
  }, []);

  const changePlatformTheme = () => {
    setPlatformTheme(createTheme(getTheme()));
  };

  return (
    <ThemeProvider theme={platformTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};
